import * as React from 'react';

export const TickSvg = (props: any) => {
	return (
		<svg
			width='16'
			height='16'
			viewBox='0 0 16 16'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			{...props}
		>
			<path
				d='M14 3.33325L5.75 11.9999L2 8.06052'
				stroke='#444444'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export const CrossCircleSvg = (props: React.SVGProps<SVGSVGElement>) => {
	return (
		<svg
			width='24'
			height='24'
			viewBox='0 0 24 24'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			{...props}
		>
			<circle cx='12' cy='12' r='10.5' stroke='#EF0404' />
			<path
				d='M16.005 7.5L7.5 16.005'
				stroke='#EF0404'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M7.5 7.5L16.005 16.005'
				stroke='#EF0404'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export const TickCircleSvg = (props: React.SVGProps<SVGSVGElement>) => {
	return (
		<svg
			width='24'
			height='24'
			viewBox='0 0 24 24'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			{...props}
		>
			<path
				d='M22 11.08V12C21.9988 14.1564 21.3005 16.2547 20.0093 17.9818C18.7182 19.709 16.9033 20.9725 14.8354 21.5839C12.7674 22.1953 10.5573 22.1219 8.53447 21.3746C6.51168 20.6273 4.78465 19.2461 3.61096 17.4371C2.43727 15.628 1.87979 13.4881 2.02168 11.3363C2.16356 9.18455 2.99721 7.13631 4.39828 5.49706C5.79935 3.85781 7.69279 2.71537 9.79619 2.24013C11.8996 1.7649 14.1003 1.98232 16.07 2.85999'
				stroke='#088943'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M22 4L12 14.01L9 11.01'
				stroke='#088943'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export const ClockSvg = (props: React.SVGProps<SVGSVGElement>) => {
	return (
		<svg
			width='24'
			height='24'
			viewBox='0 0 24 24'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			{...props}
		>
			<path
				d='M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z'
				stroke='#088943'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M11.25 6V12L17.25 15'
				stroke='#088943'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export const ChevronRightSvg = ({
	stroke = '#444444',
	...props
}: React.SVGProps<SVGSVGElement>) => {
	return (
		<svg
			width='12'
			height='12'
			viewBox='0 0 12 12'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			{...props}
		>
			<path
				d='M3.5 11L8.5 6L3.5 1'
				stroke={stroke}
				strokeWidth='1.2'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};
